import { LOCALE } from './constants';

export const formatDate = dateString => {
  const date = new Date(dateString);
  const formatter = new Intl.DateTimeFormat(LOCALE, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });
  return formatter.format(date);
};
